import React, {useEffect, useState} from "react";
import {getResponses, IResponse, NEW_RESPONSE_EVENT} from "dev/axiosInterceptors";
import {ListGroup, ListGroupItem} from "reactstrap";

export const DebugApp = () => {

  const [responses , setResponses] = useState<IResponse[]>(getResponses())

  useEffect(()=>{
    const handler = ()=>{
      setResponses([...getResponses()])
    }
    window.addEventListener(NEW_RESPONSE_EVENT,handler)
    return () => window.removeEventListener(NEW_RESPONSE_EVENT, handler)
  },[])

  return (
    <div style={{fontSize: 12}}>
      <ListGroup>
        {responses.reverse().map((resp)=>(
          <ListGroupItem style={{padding: 4}}>
            {resp.url}
            <div style={{fontSize: 12}}>
              {/* eslint-disable-next-line react/jsx-no-target-blank */}
              <b>{resp.date.toISOString()}</b> <a href={resp.headers["x-debug-token-link"]} target={"_blank"}>profiler</a>
            </div>
          </ListGroupItem>
      ))}
      </ListGroup>
    </div>
  )
}
